import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loading() {
  return (
    <div className="min-h-screen grid place-items-center bg-[#101820]">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 rounded-full border-2 border-[#C79A3B] border-t-transparent animate-spin" />
        <span className="text-[#C79A3B] font-heading tracking-widest text-sm">KERA</span>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/login"} state={{ from: loc.pathname }} replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (role === "candidate" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
